import { withInstall } from '../../../utils/with-install'
import MarkerCluster from './MarkerCluster.vue'

export const ElAmapMarkerCluster = withInstall(MarkerCluster)
export default ElAmapMarkerCluster
